import { FC } from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { useOrder } from "../../hooks/useOrder";

import PixImg from "../../assets/images/pix.png";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";

import styles from "./index.module.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import {
  CustomerType,
  FrenetDeliveryMethodType,
  MeasureType,
  OrderAddress,
  OrderContext,
  ProductType,
} from "../../contexts/OrderContext";
import { PluginspaceResponseType } from "../../contexts/PluginspaceContext";
import { ModalDelivery } from "../../components/ModalDelivery";
import Swal from "sweetalert2";
import {
  cepNoMask,
  cpfCnpjNoMask,
  cpfMask,
  rtcToText,
} from "../../functions/mask";
import { ModalTerms } from "../../components/ModalTerms";
import { Input } from "../../components/Input/Input";
import Switch from "../../components/Switch/Switch";
import { useToast } from "../../hooks/useToast";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import { SumaryOrder } from "../../components/sumaryOrder/sumaryOrder.module";
import { ChooseAddressOrder } from "../../components/chooseAddressOrder/chooseAddressOrder";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";

type PluginconfigType = {
  id: number;
  pluginspaceId: number;
  plugintypeId: number;
  plugintemplateId: {
    id: number;
    name: string;
  };
  name: string;
  content: any;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

type ProcessorWalletType = {
  externalCode: string;
  processorId: string;
};

type WalletType = {
  id: string;
  code: string;
  logo: string;
  name: string;
  processorDigitalWallets: ProcessorWalletType[];
};

type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures?: MeasureType;
  }>;
};

type PlansType = {
  id: number;
  codePlan: number;
  installment: number;
};

type IntegrationType = {
  id: number;
  pluginconfigId: number;
  brand: string;
  cardOperator: number;
  codePay: string;
  nameGateway: string;
  paymentPlans: PlansType[];
  typePay: string;
  plugintemplateId: number;
};

export type VolumeFrenetType = {
  Height: number;
  Length: number;
  Weight: number;
  Width: number;
  Quantity: number;
  SKU: string;
};

const NewOrderInfo: FC = () => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const orderContext = useOrder();
  const { getToken, getLocations, getThisPluginspace, registerAccess } =
    usePluginspace();
  const toastComponent = useToast();
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const [findCep, setFindCep] = useState(false);

  const [customer, setCustomer] = useState<CustomerType>();
  const [type, setType] = useState("");

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [total, setTotal] = useState(0);

  const [isCounter, setIsCounter] = useState(false);
  const [sellerInfo, setSellerInfo] = useState<any>(null);
  const [loadingHeader, setLoadingHeader] = useState(true);

  /*Valor do frete */
  const [valueWithDraw, setValueWithDraw] = useState(0);
  const [valueCep, setValueCep] = useState(0);
  const [cep, setCep] = useState("");
  const [freightFind, setFreightFind] = useState(0);
  const [typeFreight, setTypeFreight] = useState("withdraw");
  const [customerAddresses, setCustomerAddresses] = useState([]);

  const [customerInfoComplete, setCustomerInfoComplete] = useState();
  const [frenetMethods, setFrenetMethods] = useState<
    FrenetDeliveryMethodType[]
  >([]);

  useEffect(() => {
    registerAccess("order");
    getConfig();
    const isCounterStorage = localStorage.getItem("counter_number");
    setIsCounter(isCounterStorage ? true : false);
  }, []);

  async function loadOrder() {
    const customerStorage = await orderContext.getCustomer();
    const typeStorage = await orderContext.getType();
    const orderAddressStorage = await orderContext.getOrderAddress();
    orderContext.setCpfInNote("");
    const totalValue = await orderContext.getTotalValue();
    const freight = await orderContext.getFreight();
    const freightType = await orderContext.getType();

    setTypeFreight(freightType);

    setTotal(totalValue + freight);
    setCustomer(customerStorage);
    setType(typeStorage);
    setOrderAddress(orderAddressStorage);
    if (customerStorage && customerStorage.cep) {
      await verifyFrenet(customerStorage.cep);
    }
    if (freightType === "delivery") {
      setValueCep(freight);
      setCep(orderAddressStorage.cep);
      setFindCep(true);
      setShouldUpdate(false);
      setFreightFind(freight);
    } else if (!valueCep && customerStorage && customerStorage.cep) {
      let value = 0;
      if (!findCep) {
        value = await findCepDeliveryCustomerCep(customerStorage.cep, true);
      }
      setFreightFind(value);
    }
  }

  async function getSellerInfo() {
    const sellerCPF = await orderContext.getSellerCpfCnpj();

    if (sellerCPF) {
      await api
        .post(
          "api/users/seller",
          {
            cpf: sellerCPF,
          },

          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setSellerInfo(response.data.data[0]);
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro ao encontrar loja",
          });
        });
    }
  }

  async function getConfig() {
    setLoading(true);
    setLoadingHeader(true);
    const findedConfig: ConfigType | void = await getAppConfig();

    if (findedConfig) {
      const value = findedConfig!.content.pdv.withDrawFee
        ? parseFloat(findedConfig!.content.pdv.withDrawFee.toString())
        : 0;
      setValueWithDraw(value);
      setFreightFind(value);
    }

    setLoadingHeader(false);
    setConfig(findedConfig);
    await orderContext.synchronizeContextToStorage();
    await getCustomerAddresses();
    await loadOrder();
    await getSellerInfo();
    setLoading(false);
  }

  async function nextStep() {
    try {
      const newLocation = await getLocations();

      const deliveryActive =
        config && config.content.pdv.internalDelivery ? true : false;

      const witdrawActive = newLocation.find(
        (location) => location.code === "withdraw"
      );

      if (!witdrawActive && !(deliveryActive && findCep)) {
        toastComponent.openToast(
          "warning",
          "Essa loja não possui formas de modalidades disponíveis",
          6000
        );

        return null;
      }

      if (typeFreight === "withdraw") {
        orderContext.setFreight(valueWithDraw);
      } else if (typeFreight.includes("delivery") && findCep) {
        orderContext.setFreight(freightFind);
      }

      orderContext.setType(typeFreight);

      if (
        (typeFreight.includes("delivery") && findCep) ||
        typeFreight.includes("delivery-")
      ) {
        navigate(`/${pluginspace_id}/new-choose-payment`);
      } else if (typeFreight === "withdraw" && witdrawActive) {
        navigate(`/${pluginspace_id}/new-choose-payment`);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Selecione um meio de entrega válido",
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerAddresses() {
    try {
      const customer = await orderContext.getCustomer();

      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: customer?.cpf,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.data.length > 0) {
            const data = response.data.data[0];
            setCustomerInfoComplete(data);
            setCustomerAddresses(data.customerAddresses);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }

  async function getConfigFrenet() {
    try {
      const response = await api.post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 119,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );

      const config = response.data.data.filter(
        (el: any) =>
          el.content?.deep &&
          el.content?.height &&
          el.content?.weight &&
          el.content?.width
      );

      if (config.length > 0) {
        const { deep, height, weight, width } = config[0].content;
        return { deep, height, weight, width };
      }
      return null;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async function verifyFrenet(cep: string) {
    const orderNow = await orderContext.getOrder();
    if (orderNow && orderNow.products) {
      let volumes: VolumeFrenetType[] = [];
      let shipmentInvoiceValue = 0;

      // Obter os valores padrão
      const defaultValues = await getConfigFrenet();
      const height = defaultValues?.height || 0;
      const deep = defaultValues?.deep || 0;
      const weight = defaultValues?.weight || 0;
      const width = defaultValues?.width || 0;

      orderNow.products.forEach((prod) => {
        volumes.push({
          Height: prod.measures?.height || Number(height),
          Length: prod.measures?.lenght || Number(deep),
          Weight: prod.measures?.weight || Number(weight),
          Width: prod.measures?.width || Number(width),
          Quantity: prod.quantity,
          SKU: prod.sku,
        });
        shipmentInvoiceValue +=
          prod.unitPrice !== prod.promotionalPrice &&
          prod.promotionalPrice !== 0
            ? prod.promotionalPrice
            : prod.unitPrice;
      });
      return await api
        .post(
          "/api/frenet/quote",
          {
            recipientCep: cep,
            shipmentInvoiceValue,
            shippingItemArray: volumes,
            recipientCountry: "BR",
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          const frenetResponse = response.data;
          if (
            frenetResponse.success &&
            frenetResponse.data &&
            frenetResponse.data.ShippingSevicesArray &&
            frenetResponse.data.ShippingSevicesArray.length > 0
          ) {
            const newFrenetItens =
              frenetResponse.data.ShippingSevicesArray.filter(
                (frenetItem: FrenetDeliveryMethodType) => !frenetItem.Error
              );
            setFrenetMethods(newFrenetItens);
            return newFrenetItens;
          } else {
            setFrenetMethods([]);
            return [];
          }
        })
        .catch((err) => {
          console.log(err);
          setFrenetMethods([]);
          return [];
        });
    }
  }

  async function findCepDeliveryCustomerCep(cep: string, noAlarm?: boolean) {
    let urlSearchValid = "";
    const findedConfig: ConfigType | void = await getAppConfig();
    if (findedConfig) {
      switch (findedConfig.content.pdv.restrictCep) {
        case "cep":
          urlSearchValid = `/api/zip-code/valid/${cep}`;
          break;
        case "area":
          urlSearchValid = `/api/delivery/valid/${cep}`;
          break;
        case "mapa":
          urlSearchValid = `/api/delivery-area/valid/${cep}`;
          break;
        default:
          urlSearchValid = `/api/zip-code/valid/${cep}`;
          break;
      }
    } else urlSearchValid = `/api/zip-code/valid/${cep}`;
    setLoading(true);
    const frenetItems = await verifyFrenet(cep);
    return await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const findedCeps = response.data.data;
        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);
          setCep(cep);
          setValueCep(findedCeps[0].valor);
          setShouldUpdate(false);
          setLoading(false);
          return findedCeps[0].valor;
        } else if (!noAlarm) {
          setLoading(false);
          // if (!frenetItems || !frenetItems.length) {
          //   Swal.fire({
          //     icon: "warning",
          //     title: "Atenção!",
          //     text: "Não foi possível encontrar formas de envio para o CEP",
          //   });
          // }

          setFindCep(false);
          return 0;
        }
      })
      .catch((err) => {
        setLoading(false);
        setFindCep(false);
        console.log(err);
        return 0;
      });
  }

  return (
    <div className={styles.order_info}>
      <div className={styles.content_order_info}>
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className={styles.content_order_info_content}>
            <div className={styles.content_order_info_content_body}>
              <CheckoutOrder position={2} name={"forma de entrega"} />
              <SumaryOrder page="informacao"/>
              <ChooseAddressOrder
                deliveryActive={
                  config && config.content.pdv.internalDelivery ? true : false
                }
                withDrawValue={valueWithDraw}
                deliveryDrawValue={valueCep}
                setCep={setCep}
                cep={cep}
                setTypeFreight={setTypeFreight}
                setFreightFind={setFreightFind}
                typeFreight={typeFreight}
                customerAddresses={customerAddresses}
                setAllcustomerAddresses={setCustomerAddresses}
                findCepDeliveryCustomerCep={findCepDeliveryCustomerCep}
                setFindCep={setFindCep}
                findCep={findCep}
                shouldUpdate={shouldUpdate}
                customerName={customer ? customer.name : ""}
                customerPhone={customer ? customer.telephone : ""}
                customerInfoComplete={customerInfoComplete}
                frenetMethods={frenetMethods}
                config={config}
              />
            </div>
            {!loading && (
              <ButtonCheckout
                action={() => nextStep()}
                label={"Continuar"}
                backgroundColor={
                  config?.webappcolor.webappbutton
                    ? config.webappcolor.webappbutton
                    : "#EAEAEA"
                }
                color={
                  config?.webappcolor.fontbutton
                    ? config?.webappcolor.fontbutton
                    : "#636363"
                }
                marginBottom
              />
            )}
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
};

export { NewOrderInfo };
